module.exports = __webpack_public_path__ + "img/poro-angry.36e3725d.png";